import { List, Spin, Typography } from 'antd';
import { EmptyData } from 'assets';
import { Avatar, customizeRenderEmpty, InputSearch } from 'components/common';
import { useAgents, useUsersOptions } from 'hooks';
import { omniChatMessages } from 'messages';
import VirtualList from 'rc-virtual-list';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { AgentDto, UserCompactDto } from 'types';
import { includesRemoveSpecial } from 'utils';

type OmniChatSessionAgentListProps = {
  onClickItem?: (id: number, user: UserCompactDto) => void;
  className?: string;
  placeholder?: string;
  selectedUserId?: number;
};

const OmniChatSessionAgentList: React.FC<OmniChatSessionAgentListProps> = ({
  onClickItem,
  className,
  placeholder,
  selectedUserId
}) => {
  const [keyword, setKeyword] = useState('');
  const { agents, isLoading, isFetching } = useAgents(
    {},
    {
      refetchOnMountOrArgChange: true
    }
  );

  const handleSearch = (val: string) => {
    setKeyword(val);
  };

  const agentList = agents.filter((o) => includesRemoveSpecial(o.fullName, keyword));

  return (
    <div className={twMerge('flex max-h-full flex-col px-4', className)}>
      <InputSearch
        className='mb-4 rounded-lg border'
        placeholder={placeholder ?? omniChatMessages.nameDTV}
        onChange={(e) => handleSearch(e.toString())}
        isDebounce={false}
      />
      <Spin spinning={isLoading || isFetching}>
        {agentList.length ? (
          <List className='-mx-4 max-h-[calc(100%-48px)] overflow-auto pb-6'>
            <VirtualList itemKey='userId' data={agentList} fullHeight>
              {(item: AgentDto) => (
                <List.Item
                  key={item.userId}
                  className={twMerge(
                    'cursor-pointer px-5 transition-all',
                    selectedUserId === item.userId ? 'bg-backgroundColor4' : 'hover:bg-colorBgIconHover'
                  )}
                  onClick={() => onClickItem?.(item.userId, item)}
                >
                  <List.Item.Meta
                    avatar={<Avatar size={48} fileId={item.avatar} name={item.fullName} />}
                    title={
                      <Typography.Title level={5} className='m-0'>
                        {item.fullName}
                      </Typography.Title>
                    }
                    description={
                      <Typography.Text className='m-0 text-sm' type='secondary'>
                        {item.totalChatSessionProcessing} {omniChatMessages.chatSession}
                      </Typography.Text>
                    }
                  />
                </List.Item>
              )}
            </VirtualList>
          </List>
        ) : (
          customizeRenderEmpty()
        )}
      </Spin>
    </div>
  );
};

export default OmniChatSessionAgentList;
